import { NumberAbbreviation } from '@/components/UI/NumberFormatDisplay/NumberAbbreviation';
import { useDashboardData } from '@/hooks/ReactQueryHooks/useDashboardQuery';
import type { DashboardType } from '@/types/Analytics.ts';
import { transformProjectTypeChartDataSets } from '@/utils';
import Card from '../../UI/Card/index.tsx';
import PieChartECharts from '../../UI/Charts/PieChart/index1';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

export interface ProjectTypeProps {
  projectType: string;
  _count: number;
  units: number;
}

export default function ProjectTypeWidget({ dashboard }: { dashboard: DashboardType }) {
  const fetchProjectTypeWidgetData = useDashboardData({
    dashboard,
    widget: Widget.PROJECTS_BY_PROJECT_TYPE,
  });

  const projectTypeWidgetData = fetchProjectTypeWidgetData?.data?.data;
  const projectTypeLabels = projectTypeWidgetData?.map((data: ProjectTypeProps) => data?.projectType);

  const projectsByProjectType = projectTypeWidgetData?.map((data: ProjectTypeProps) => ({
    type: data?.projectType,
    count: data?._count,
  }));
  const projectTypeChartDatasets = transformProjectTypeChartDataSets(projectsByProjectType);

  const totalProjectType = projectTypeWidgetData?.reduce((acc: number, data: ProjectTypeProps) => acc + data?._count, 0);

  const projectTypeChartData = (projectsByProjectType ?? []).map((item: { type: string; count: number }, index: number) => ({
    value: item.count,
    name: item.type,
    color: projectTypeChartDatasets[index]?.color,
  }));

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.PROJECTS_BY_PROJECT_TYPE}>
      <Card title='Projects By Development Type' error={fetchProjectTypeWidgetData.isError}>
        {projectTypeLabels?.length > 0 ? (
          <div className='flex h-full min-h-[500px] w-full min-w-0 flex-col justify-start px-5 pt-4'>
            <div className='relative z-10 shrink-0 text-start py-2'>
              <h3 className='text-neutralColor-normal'>Total Projects</h3>
              <h1 className='m-0'>
                <NumberAbbreviation value={totalProjectType} prefix='' />
              </h1>
            </div>

            <div className='min-w-0 w-full overflow-visible'>
              <PieChartECharts data={projectTypeChartData} containerClassName='min-w-0 w-full' />
            </div>
          </div>
        ) : (
          <div className='flex h-full min-h-[500px] items-center justify-center p-5'>
            <h2>There are no projects by development type.</h2>
          </div>
        )}
      </Card>
    </WidgetLayout>
  );
}
